import {KTCard} from '../../../_metronic/helpers'
import {ListHeader} from './components/header/ListHeader'
// import {ListViewProvider, useListView} from '../data-table/core/ListViewProvider'

import {PaymentTable} from './PaymentsTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {ListViewProvider, useListView} from './core/ListViewProvider'
// import {PaymentEditModal} from './plan-add-edit/PaymentEditModal'

const PaymentList = () => {
  // const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ListHeader />
        <PaymentTable />
      </KTCard>
      {/* {itemIdForUpdate !== undefined && <PaymentEditModal />} */}
    </>
  )
}

const PaymentListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PaymentList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PaymentListWrapper}
